// import myDB from "@/utils/indexedDB";
import Cookies from "js-cookie";
export default {
  setCache(data) {
    localStorage.setItem("tokenlsc", data);
    Cookies.set("tokenlsc", data, { expires: 36500 });
    // return new Promise((resolve, reject) => {
    //     myDB.openDB("t_token").then((db) => {
    //         myDB.updateDB(db, "myToken", { "tokenlscId": "mykey", "tokenVal": data });
    //         resolve();
    //     })
    // })
  },
  getCache() {
    let t1 = localStorage.getItem("tokenlsc");
    if (t1) {
      return t1;
    }
    let t2 = Cookies.get("tokenlsc");
    if (t2) {
      return t2;
    }
    return null;
    // return new Promise((resolve, reject) => {
    //   let t1 = localStorage.getItem("tokenlsc");
    //   if (t1) {
    //     resolve(t1);
    //     return;
    //   }
    //   let t2 = Cookies.get("tokenlsc");
    //   if (t2) {
    //     resolve(t2);
    //     return;
    //   }
    //   resolve(null);
    // myDB.openDB("t_token").then((db) => {
    //     myDB.getDataByKey(db, "myToken", "mykey").then(res => {
    //         if (res && res.tokenVal) {
    //             resolve(res.tokenVal)
    //         } else {
    //             resolve(null)
    //         }
    //     })
    // })
    //);
  },
  removeCache() {
    localStorage.removeItem("tokenlsc");
    Cookies.remove("tokenlsc");
    // myDB.openDB("t_token").then(db => {
    //   myDB.deleteDB(db, "myToken", "mykey");
    // });
  }
};



// WEBPACK FOOTER //
// ./src/utils/loginCache.js